export class TeamQueueInformation {
  teamTitle: string
  abstractsCompleted: number
  abstractsRemaining: number
  applIdCurrentlyInProgress: string
  abstractIdCurrentlyInProgress: number
  abstractGroupCurrentlyInProgress: boolean
}
